import { EntityModel } from '@/interfaces'
import {
  ALL_BESTSELLER_SLIDER_BLOCKS_QUERY,
  CREATE_BESTSELLER_SLIDER_BLOCK_MUTATION,
  DELETE_BESTSELLER_SLIDER_BLOCK_MUTATION,
  FORCE_DELETE_BESTSELLER_SLIDER_BLOCK_MUTATION,
  SINGLE_BESTSELLER_SLIDER_BLOCK_QUERY,
  UPDATE_BESTSELLER_SLIDER_BLOCK_MUTATION,
} from './graphql'

const cmsBestsellerSliderBlockModel: EntityModel = {
  name: 'bestsellerSliderBlock',
  namePlural: 'bestsellerSliderBlocks',
  uniqueName: 'cmsBestsellerSliderBlock',
  uniqueNamePlural: 'cmsBestsellerSliderBlocks',
  path: 'cms/blocks/bestseller_slider_block',
  baseUrl: '/cms/blocks/bestseller_slider_blocks',
  translationPrefix: 'entities:cmsBestsellerSliderBlock.',
  getDisplayName: (values: any) => {
    return 'Bestseller Slider Block'
  },
  gql: {
    getAll: ALL_BESTSELLER_SLIDER_BLOCKS_QUERY,
    getSingle: SINGLE_BESTSELLER_SLIDER_BLOCK_QUERY,
    create: CREATE_BESTSELLER_SLIDER_BLOCK_MUTATION,
    update: UPDATE_BESTSELLER_SLIDER_BLOCK_MUTATION,
    delete: DELETE_BESTSELLER_SLIDER_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_BESTSELLER_SLIDER_BLOCK_MUTATION,
  },
  attributes: {
    fluid: {
      name: 'fluid',
      label: 'entities:cmsBestsellerSliderBlock.attributes.fluid.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: false,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsBestsellerSliderBlockModel
